define('home/templates/topicInput',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : {}, alias2=container.escapeExpression;

  return "<h3 class=\"spacing-default text-gray-darker\">\n"
    + alias2(helpers.gettext.call(alias1,"Topics",{"name":"gettext","hash":{},"data":data}))
    + "\n</h3>\n\n<div data-attribute=\"topics\" class=\"input-group\">\n<div data-role=\"topics\"></div>\n<input class=\"input-group__text\" name=\"topics\" type=\"text\"\nplaceholder=\""
    + alias2(helpers.gettext.call(alias1,"Add topics here, separate with commas.",{"name":"gettext","hash":{},"data":data}))
    + "\" />\n</div>\n\n<div data-role=\"attribute-error\" class=\"form-message-error text-small spacing-default\"></div>\n";
},"useData":true})

});
